import React from 'react';
import {Preparation} from "@gull";

const MasterCloudPreparation = (props) =>{
    
    if(props.modulePos.params.to_prepare.active){
        return(<Preparation {...props}/>)
        
    }else{
        return(<></>)
    }
};

export default MasterCloudPreparation;